/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfListOfNotificationsListDto } from '../models/custom-result-of-list-of-notifications-list-dto';
import { notificationsCreateNotificationSeen } from '../fn/notifications/notifications-create-notification-seen';
import { NotificationsCreateNotificationSeen$Params } from '../fn/notifications/notifications-create-notification-seen';
import { notificationsCreateNotificationsSeen } from '../fn/notifications/notifications-create-notifications-seen';
import { NotificationsCreateNotificationsSeen$Params } from '../fn/notifications/notifications-create-notifications-seen';
import { notificationsGetNotificationsList } from '../fn/notifications/notifications-get-notifications-list';
import { NotificationsGetNotificationsList$Params } from '../fn/notifications/notifications-get-notifications-list';
import { notificationsGetSocketModel } from '../fn/notifications/notifications-get-socket-model';
import { NotificationsGetSocketModel$Params } from '../fn/notifications/notifications-get-socket-model';
import { SocketAddNotificationModel } from '../models/socket-add-notification-model';

@Injectable({ providedIn: 'root' })
export class NotificationsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `notificationsGetNotificationsList()` */
  static readonly NotificationsGetNotificationsListPath = '/Notifications/GetNotificationsList';

  /**
   * دریافت لیست اعلانات کاربر فعلی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notificationsGetNotificationsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationsGetNotificationsList$Response(params?: NotificationsGetNotificationsList$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfNotificationsListDto>> {
    return notificationsGetNotificationsList(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لیست اعلانات کاربر فعلی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `notificationsGetNotificationsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationsGetNotificationsList(params?: NotificationsGetNotificationsList$Params, context?: HttpContext): Observable<CustomResultOfListOfNotificationsListDto> {
    return this.notificationsGetNotificationsList$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfNotificationsListDto>): CustomResultOfListOfNotificationsListDto => r.body)
    );
  }

  /** Path part for operation `notificationsCreateNotificationSeen()` */
  static readonly NotificationsCreateNotificationSeenPath = '/Notifications/CreateNotificationSeen';

  /**
   * افزودن یک اعلان به دیده شده ها.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notificationsCreateNotificationSeen()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  notificationsCreateNotificationSeen$Response(params: NotificationsCreateNotificationSeen$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return notificationsCreateNotificationSeen(this.http, this.rootUrl, params, context);
  }

  /**
   * افزودن یک اعلان به دیده شده ها.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `notificationsCreateNotificationSeen$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  notificationsCreateNotificationSeen(params: NotificationsCreateNotificationSeen$Params, context?: HttpContext): Observable<CustomResult> {
    return this.notificationsCreateNotificationSeen$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `notificationsCreateNotificationsSeen()` */
  static readonly NotificationsCreateNotificationsSeenPath = '/Notifications/CreateNotificationsSeen';

  /**
   * افزودن لیست اعلان ها به دیده شده ها.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notificationsCreateNotificationsSeen()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  notificationsCreateNotificationsSeen$Response(params: NotificationsCreateNotificationsSeen$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return notificationsCreateNotificationsSeen(this.http, this.rootUrl, params, context);
  }

  /**
   * افزودن لیست اعلان ها به دیده شده ها.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `notificationsCreateNotificationsSeen$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  notificationsCreateNotificationsSeen(params: NotificationsCreateNotificationsSeen$Params, context?: HttpContext): Observable<CustomResult> {
    return this.notificationsCreateNotificationsSeen$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `notificationsGetSocketModel()` */
  static readonly NotificationsGetSocketModelPath = '/Notifications/GetSocketModel';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notificationsGetSocketModel()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationsGetSocketModel$Response(params?: NotificationsGetSocketModel$Params, context?: HttpContext): Observable<StrictHttpResponse<SocketAddNotificationModel>> {
    return notificationsGetSocketModel(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `notificationsGetSocketModel$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationsGetSocketModel(params?: NotificationsGetSocketModel$Params, context?: HttpContext): Observable<SocketAddNotificationModel> {
    return this.notificationsGetSocketModel$Response(params, context).pipe(
      map((r: StrictHttpResponse<SocketAddNotificationModel>): SocketAddNotificationModel => r.body)
    );
  }

}
